export function getViewerPermissionIdString(value: unknown): string | undefined {
  if (typeof value === "string") {
    return value;
  }

  if (typeof value !== "object" || value === null) {
    return undefined;
  }

  if ("_id" in value) {
    return getViewerPermissionIdString(value._id);
  }

  if ("$oid" in value) {
    return getViewerPermissionIdString(value.$oid);
  }

  if ("id" in value) {
    return getViewerPermissionIdString(value.id);
  }

  const stringValue = value.toString();
  if (stringValue !== "[object Object]") {
    return stringValue;
  }

  return undefined;
}

export function getViewerPermissionIdStrings(
  ...values: unknown[]
): Set<string> {
  return new Set(
    values
      .map((value) => getViewerPermissionIdString(value))
      .filter((value): value is string => value !== undefined),
  );
}
